import { ApiClientErrorResponse } from '~/ApiClient';

import { ErrorCode } from './Error';
import { mapError } from './mapError';
import ValidationResult from './ValidationResult';

export default class ErrorResponse extends ApiClientErrorResponse {
	handleProductGroupLocked(): boolean {
		return this.handle('product-group-locked');
	}

	handleProductGroupNotFound(): boolean {
		return this.handle('product-group-not-found');
	}

	handleCannotChangeSettingsForNonMemberProducts(): boolean {
		return this.handle(ErrorCode.cannotChangeSettingsForNonMemberProducts);
	}

	handleProductSettingsMissing(): boolean {
		return this.handle(ErrorCode.productSettingsMissing);
	}

	handleReferenceCountryProductMissing(): boolean {
		return this.handle(ErrorCode.referenceCountryProductMissing);
	}

	handleAtMostOneProductPerCountry(): boolean {
		return this.handle(ErrorCode.atMostOneProductPerCountry);
	}

	handleReferenceSettingsMissing(): boolean {
		return this.handle(ErrorCode.referenceSettingsMissing);
	}

	handleIllegalPriceTypeSelected(): boolean {
		return this.handle(ErrorCode.illegalPriceTypeSelected);
	}

	toValidationResult(): ValidationResult {
		const errors = this.errors.map(mapError);

		return new ValidationResult(
			errors.find((error) => error.missingSettings.size > 0)?.missingSettings ?? new Set(),
			errors.filter((error) => error.productId !== null),
			errors.filter((error) => error.duplicateCountries.length > 0)
		);
	}
}
